module.exports = __webpack_public_path__ + "static/img/GBZ965-FCL-399-BB-2.03c6127.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/products/2027/GBZ965-FCL-399-BB-2.jpg
// module id = E6oI
// module chunks = 0